import { render, staticRenderFns } from "./CustomerAlert.vue?vue&type=template&id=38ad96fd&scoped=true"
import script from "./CustomerAlert.vue?vue&type=script&lang=js"
export * from "./CustomerAlert.vue?vue&type=script&lang=js"
import style0 from "./CustomerAlert.vue?vue&type=style&index=0&id=38ad96fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ad96fd",
  null
  
)

export default component.exports